import(/* webpackMode: "eager" */ "/app/frontend/src/app/(auth)/login/page.tsx");
